<script>
    import {Link, navigate} from "svelte-routing";
    import TopMenu from "../components/TopMenu.svelte";
    import Modal from "../components/Modal.svelte";
    import {network, store} from "../stores";
    import moment from "moment/moment";
    import {onMount} from "svelte";

    export let vid, id;

    const user = store('credential', 'getAuth');


    let isLoading = true
    let loadError = ''
    let item = []
    let isModalOpen = false
    let isPdfModalOpen = false

    const getSingleItemFromList = async () => {
        isLoading = true
        loadError = ''
        try {
            const order = await network.getSingleItemFromList({vid, nomer: id})
            if (!Array.isArray(order) || !order.length) {
                throw new Error('Пустой ответ')
            }
            item = order
        } catch (error) {
            console.error(error)
            loadError = 'Не удалось загрузить заявку. Проверьте связь и повторите.'
        }
        isLoading = false
    }

    const getDocument = (down) => {
        const WIDTH = 950
        const HEIGHT = 2000
        const API_KEY = 1691521787754
        let main = 'report.trademaster.pro'
        let base =''
        let idSklad =''

        let url = ''



        if (APP_TYPE === 'axis-plisse') {

            if (down) {
                url = `https://axis.setka-plisse.ru/reportViborka.aspx?nom=${item[0].nomer}&vid=16&width=${WIDTH}&height=${HEIGHT}&print=1&nomStr=${item[0].nomerStr}&idSklad=${+$user.idSklad}&apikey=setka-plisse`
            } else {
                url = `https://axis.setka-plisse.ru/reportViborka.aspx?nom=${item[0].nomer}&vid=36&width=${WIDTH}&height=${HEIGHT}&print=0&nomStr=${item[0].nomerStr}&idSklad=${+$user.idSklad}&apikey=setka-plisse`
            }
        }
        if (APP_TYPE === 'axis-one') {
            base='Axis'
            if (down) {
                url = `https://${main}/Reports/${base}/reportViborka.aspx?nom=${item[0].nomer}&vid=16&width=${WIDTH}&height=${HEIGHT}&pdf=1&nomStr=${item[0].nomerStr}&idSklad=${+$user.idSklad}`
            } else {
                url = `https://${main}/Reports/${base}/reportViborka.aspx?nom=${item[0].nomer}&vid=36&width=${WIDTH}&height=${HEIGHT}&pdf=0&nomStr=${item[0].nomerStr}&idSklad=${+$user.idSklad}`
            }
        }
        if (APP_TYPE === 'moskitoscompany') {
            base='moskitoscompany'
            if (down) {
                url = `https://${main}/Reports/${base}/reportViborka.aspx?nom=${item[0].nomer}&vid=16&width=${WIDTH}&height=${HEIGHT}&pdf=1&nomStr=${item[0].nomerStr}&idSklad=${+$user.idSklad}`
            } else {
                url = `https://${main}/Reports/${base}/reportViborka.aspx?nom=${item[0].nomer}&vid=46&width=${WIDTH}&height=${HEIGHT}&pdf=0&nomStr=${item[0].nomerStr}&idSklad=${+$user.idSklad}`
            }

        }
        if (APP_TYPE === 'setkipro') {
            base='setkipro'
            if (down) {
                url = `https://b2b.plisser.ru/reportViborka.aspx?nom=${item[0].nomer}&vid=16&width=${WIDTH}&height=${HEIGHT}&pdf=1&nomStr=${item[0].nomerStr}&idSklad=${+$user.idSklad}&apikey=plisser`
            } else {
                url = `https://b2b.plisser.ru/reportViborka.aspx?nom=${item[0].nomer}&vid=36&width=${WIDTH}&height=${HEIGHT}&pdf=0&nomStr=${item[0].nomerStr}&idSklad=${+$user.idSklad}&apikey=plisser`
            }
        }
        if (APP_TYPE === 'plisse-ltd') {
            base='plisseltd'
            if (down) {
                url = `https://${main}/Reports/${base}/reportViborka.aspx?nom=${item[0].nomer}&vid=16&width=${WIDTH}&height=${HEIGHT}&pdf=1&nomStr=${item[0].nomerStr}&idSklad=${+$user.idSklad}`
            } else {
                url = `https://${main}/Reports/${base}/reportViborka.aspx?nom=${item[0].nomer}&vid=36&width=${WIDTH}&height=${HEIGHT}&pdf=0&nomStr=${item[0].nomerStr}&idSklad=${+$user.idSklad}`
            }
        }


        return url
    }


    const getDocumentKP = (down) => {
        const WIDTH = 950
        const HEIGHT = 2000
        const API_KEY = 1691521787754
        let main = 'report.trademaster.pro'
        let base =''
        let idSklad =''

        let url = ''
        if (APP_TYPE === 'moskitoscompany') {
            base='moskitoscompany'
            if (down) {
                url = `https://${main}/Reports/${base}/reportViborka.aspx?nom=${item[0].nomer}&vid=36&width=${WIDTH}&height=${HEIGHT}&pdf=1&nomStr=${item[0].nomerStr}&idSklad=${+$user.idSklad}`
            } else {
                url = `https://${main}/Reports/${base}/reportViborka.aspx?nom=${item[0].nomer}&vid=36&width=${WIDTH}&height=${HEIGHT}&pdf=0&nomStr=${item[0].nomerStr}&idSklad=${+$user.idSklad}`
            }
        }
        return url
    }

    let documentURL = ''
    let documentPdfURL = ''
    let documentKPPdfURL = ''

    onMount(async () => {
        await getSingleItemFromList()
        documentURL = getDocument(false)
        documentPdfURL = getDocument(true)
        documentKPPdfURL = getDocumentKP(true)

    })

    const handlerChangeParams = (order, orderStr) => {
        location.query = {};
        location.query.order = order;
        location.query.orderStr = orderStr;
        navigate('/');
    }

</script>
{#if !isLoading && !loadError}
    <TopMenu title="Детали заявки #{item[0].nomerStr}">
        <div class="d-flex {item[0].vid == 16 ? '' : 'd-none'}" slot="right">
            <a href="{documentPdfURL}" download target="_blank" class="headerButton">
                <i class="fas fa-file-pdf fa-lg"></i>
            </a>
            <a href="#" on:click={()=> isModalOpen = true} class="headerButton">
                <i class="fas fa-file fa-lg"></i>
            </a>
            {#if APP_TYPE === 'moskitoscompany'}
                <a href="{documentKPPdfURL}" download target="_blank" class="headerButton">
                    <i class="fas fa-file-pdf fa-lg"></i>
                </a>
            {/if}

            <a href="#" class="headerButton"
               on:click|preventDefault={() => {handlerChangeParams(btoa(item[0].nomer),item[0].nomerStr)}}>
                <i class="fas fa-edit fa-lg"></i>
            </a>
        </div>
    </TopMenu>
{/if}
<div class="extraHeader">
    <ul class="nav nav-tabs lined" role="tablist">
        <li class="nav-item">
            <a class="nav-link active" data-bs-toggle="tab" href="#info" role="tab" aria-selected="false">
                Информация
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" href="#contact" role="tab" aria-selected="true">
                Контакт
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" href="#items" role="tab" aria-selected="true">
                Изделия
            </a>
        </li>
    </ul>

</div>

<div id="appCapsule" class="extra-header-active">
    {#if isLoading}
        <div class="section mt-2">
            <div class="card text-center">
                <div class="card-body p-5">
                    <h5 class="card-title">Загрузка</h5>
                    <p class="card-text">
                        Пожалуйста подождите, мы загружаем информацию по вашей заявке..
                    </p>
                </div>
            </div>
        </div>
    {:else if loadError}
        <div class="section mt-2">
            <div class="card text-center">
                <div class="card-body p-5">
                    <h5 class="card-title">Нет связи</h5>
                    <p class="card-text">{loadError}</p>
                    <button type="button" class="btn btn-primary" on:click={getSingleItemFromList}>Повторить</button>
                </div>
            </div>
        </div>
    {:else}
        <div class="tab-content mt-2">
            <!-- info tab -->
            <div class="tab-pane fade active show" id="info" role="tabpanel">
                <ul class="listview">
                    <li>
                        <div class="in">
                            <div>
                                <header>Номер</header>
                                <b>{item[0].nomerStr}</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Дата</header>
                                <b>{moment(item[0].dataDo).format('DD.MM.YYYY')}</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Сумма</header>
                                <b>{Number((+item.reduce((red, izd) => red + Number(izd.summa), 0)).toFixed(0)).toLocaleString("ru-RU")}
                                    ₽</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Оплаченная сумма</header>
                                <b>{Number((+item[0].summaOpl).toFixed(0)).toLocaleString("ru-RU")} ₽</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Тип</header>
                                <b>{+item[0].vid === 16 ? 'Черновик' : +item[0].vid === 19 ? 'В работе' : +item[0].vid === 12 ? 'На складе' : 'Отгруженные'}</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Комментарий</header>
                                <b>{item[0].komment}</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Замерщик/монтажник</header>
                                <b>{item[0].driver}</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Телефон замерщика/монтажника</header>


                                <span class="d-flex justify-content-between align-content-center align-items-center">
                                    <b>{item[0].driverTel}</b>

                                    {#if item[0].driverTel}
                                    <div class="col-2 text-center">
                                        <a class="btn btn-outline-light" target="_blank"
                                           href="tel:{item[0].driverTel.replace(/[\s\(\)-]/g, '')}">
                                            <i class="fas fa-phone-square-alt fa-2x text-dark"></i>
                                        </a>
                                    </div>
                                    <div class="col-2 text-center">
                                        <a class="btn btn-outline-light" target="_blank"
                                           href="https://api.whatsapp.com/send/?phone={item[0].driverTel.replace(/\D/g, '')}">
                                            <i class="fab fa-whatsapp-square fa-2x text-success"></i>
                                        </a>
                                    </div>
                                     {/if}
                                 </span>

                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Рег. номер Замерщика/монтажника</header>
                                <b>{item[0].driverRegNom}</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Авто замерщика/монтажника</header>
                                <b>{item[0].driverAuto}</b>
                            </div>
                        </div>
                    </li>

                </ul>
            </div>
            <!-- * info tab -->

            <!-- contact tab -->
            <div class="tab-pane fade" id="contact" role="tabpanel">
                <ul class="listview mb-2">
                    <li>
                        <div class="in">
                            <div>
                                <header>Контакт</header>
                                <b>{item[0].nameKontakt}</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Юр. лицо</header>
                                <b>{item[0].kontrName}</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Телефон</header>
                                <span class="d-flex justify-content-between align-content-center align-items-center">
                                    <b>{item[0].telefonKontakt}</b>

                                    {#if item[0].telefonKontakt}
                                    <div class="col-2 text-center">
                                        <a class="btn btn-outline-light" target="_blank"
                                           href="tel:{item[0].telefonKontakt.replace(/[\s\(\)-]/g, '')}">
                                            <i class="fas fa-phone-square-alt fa-2x text-dark"></i>
                                        </a>
                                    </div>
                                    <div class="col-2 text-center">
                                        <a class="btn btn-outline-light" target="_blank"
                                           href="https://api.whatsapp.com/send/?phone={item[0].telefonKontakt.replace(/\D/g, '')}">
                                            <i class="fab fa-whatsapp-square fa-2x text-success"></i>
                                        </a>
                                    </div>
                                     {/if}
                                 </span>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Электронная почта</header>
                                <b>{item[0].other1Kontakt}</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Адрес</header>
                                <b>{item[0].adresKontakt}</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Доп.инфо</header>
                                <b>{item[0].other2Kontakt}</b>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- * contact tab -->
                <!--                <div class="carousel-button-footer">-->
                <!--                    <div class="row">-->
                <!--                        <div class="col-12">-->
                <!--                            <button type="button" class="btn btn-primary btn-lg btn-block" >Сохранить</button>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->
            </div>
            <!-- * items tab -->
            <div class="tab-pane fade" id="items" role="tabpanel">

                {#each item as izd}
                    <ul class="listview mb-2">
                        <li>
                            <div class="in">
                                <div>
                                    <header>Изделие</header>
                                    <b>{izd.name}</b>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="in">
                                <div>
                                    <header>Цена</header>
                                    <b>{Number((+izd.summa / (+izd.kolvo)).toFixed(0)).toLocaleString("ru-RU")} </b>
                                </div>
                            </div>
                        </li>

                        <li>
                            <div class="in">
                                <div>
                                    <header>Количество</header>
                                    <b>{+izd.kolvo}</b>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="in">
                                <div>
                                    <header>Общая сумма</header>
                                    <b>{Number((+izd.summa).toFixed(0)).toLocaleString("ru-RU")} ₽</b>
                                </div>
                            </div>
                        </li>
                    </ul>
                {/each}
            </div>
            <!-- * items tab -->
            <!--{#if data.order.vid === '16'}-->
            <!--    <div class="carousel-button-footer">-->
            <!--        <div class="row">-->
            <!--            <div class="col-12">-->
            <!--                <button type="button" class="btn btn-primary btn-lg btn-block" on:click={handlerSaveDelivery}>Отправить</button>-->
            <!--            </div>-->
            <!--        </div>-->
            <!--    </div>-->
            <!--{/if}-->

        </div>

        <div class="modal fade dialogbox" id="modal-save" data-bs-backdrop="static" tabindex="-1" style="display: none;"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-icon text-success">
                        <i class="fas fa-check-circle" aria-hidden="true"></i>
                    </div>
                    <div class="modal-header">
                        <h5 class="modal-title">Сохранено</h5>
                    </div>
                    <div class="modal-footer">
                        <div class="btn-inline">
                            <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--<pre>{JSON.stringify(data, null, 4)}</pre>-->
    {/if}
</div>


<Link to="/list/{vid}" class="headerButton goBack text-white ">
    <div class="col-12 col-lg-4 btn btn-primary  text-center">К заявкам</div>
</Link>
{#if !isLoading && !loadError}
    <Modal title="Коммерческое предложение" on:closing={() => (isModalOpen = false)} open={isModalOpen}>
        <style>
            .modal-body {
                padding: 0;
            }
        </style>
        <div style="height: 85vh">
            <iframe src="{documentURL}" width="100%" height="100%"></iframe>
        </div>
    </Modal>

    <!-- <Modal title="Счет на оплату" on:closing={() => (isPdfModalOpen = false)} open={isPdfModalOpen}>
         <div style="height: 85vh; width: 100%">
             <iframe src="{documentPdfURL}" width="100%" height="100%"> </iframe>
         </div>
     </Modal>-->
{/if}